import React from "react";
import bg from "../../assets/profileimage.jpg";
import "./Intro.css";

const Intro = () => {


  return (
    <section id="intro">
      <div className="introContent">
        <span className="hello">Hello,</span>
        <span className="introText">
          I'm <p className="name">Kaya Mekin</p>
        </span>
        <span className="introText2">Website & Mobile Developer.</span>
        <span className="introText2">Graphic Designer.</span>
        <br></br>
        <p className="introParagraph">
          I'm a web & mobile developer and graphic designer.
          <br /> I reside in Türkiye. <br />
        </p>
        <p className="introParagraph">
          I use Adobe programs frequently and usually illustrator, photoshop,
          <br /> I specialize in products like After Effects and Premiere Pro.
          <br />
          I have UI and UX knowledge, I prefer Figma as a program.
          <br />
          Designing and developing mobile interfaces with Flutter dart. <br />
          In the front end position, I have command of html, css, javascript,
          bootstrap, react and tailwind features.
          <br />
          I'm waiting for the day when I start my career as a young developer.
        </p>
      </div>

      <img src={bg} alt="" className="bg" />
    </section>
  );
};

export default Intro;
